import { Box } from '@mui/material';
import '../../assets/css/home.css';
import CategorySwipeable from './CategorySection';
import HeroSection from "./HeroSection";
import TrendingJobs from './TrendingJobs';
import AboutCM from './AboutCM';
import Contact from './Contact';
import { useAppSelector } from '../../hooks';
import Loading from '../../components/Loading';

const Home = () => {
  const { loading } = useAppSelector(state=> state.frontViewData)
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center' }}>
      {
        loading ? <Loading/>
        :
        <>
          <HeroSection/>
          <CategorySwipeable/>
          <TrendingJobs/>
          <AboutCM/>
          <Contact/>
        </>
      }
    </Box>
  );
};

export default Home;
